var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-box',{attrs:{"title":"Options"}},[_c('div',{staticClass:"m-block"},[_c('h5',[_vm._v("Phone Option")]),_vm._v(" "),_c('m-phone-option')],1),_vm._v(" "),_c('div',{staticClass:"m-block"},[_c('a',{on:{"click":function($event){return _vm.$router.push({'name': 'demo-suppression'})}}},[_vm._v("Add suppression")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df6cfd30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order2/MOrder2Option.vue
// module id = null
// module chunks = 